module.exports = __webpack_public_path__ + "media/images/short_scenario_contest/theme-title@2x-4efd5d2384714d4e07ecb5c5cdc7df7c.png";